export enum LoanEventType {
    VIEWED = 'VIEWED',
    CREATED = 'CREATED',
    UPDATED = 'UPDATED',
    PRICED = 'PRICED',
    REPRICED = 'REPRICED',
    FLOATED = 'FLOATED',
    LOCKED = 'LOCKED',
    RELOCKED = 'RELOCKED',
    COMMENT_CREATED = 'COMMENT_CREATED',
    COMMENT_UPDATED = 'COMMENT_UPDATED',
    COMMENT_DELETED = 'COMMENT_DELETED',
    INITIAL_DOC_PACKAGE_UPLOADED = 'INITIAL_DOC_PACKAGE_UPLOADED',
    DOCUMENT_UPLOADED = 'DOCUMENT_UPLOADED',
    LOAN_STATUS_UPDATED = 'LOAN_STATUS_UPDATED',
    UW_CONDITION_CREATED = 'UW_CONDITION_CREATED',
    UW_CONDITION_UPDATED = 'UW_CONDITION_UPDATED',
    UW_CONDITION_COMMENT_CREATED = 'UW_CONDITION_COMMENT_CREATED',
    UW_CONDITION_COMMENT_DELETED = 'UW_CONDITION_COMMENT_DELETED',
    UW_STEP_SUBMITTED = 'UW_STEP_SUBMITTED',
    SETUP_COMPLETE = 'SETUP_COMPLETE'
}

export const loanEventTypeDisplay: Record<LoanEventType, string> = {
    [LoanEventType.CREATED]: 'Loan created',
    [LoanEventType.PRICED]: 'Loan priced',
    [LoanEventType.REPRICED]: 'Loan repriced',
    [LoanEventType.LOCKED]: 'Loan locked',
    [LoanEventType.INITIAL_DOC_PACKAGE_UPLOADED]: 'Initial doc package uploaded',
    [LoanEventType.DOCUMENT_UPLOADED]: 'Document uploaded',
    [LoanEventType.SETUP_COMPLETE]: 'Setup complete',
    [LoanEventType.UPDATED]: 'Updated',
    [LoanEventType.FLOATED]: 'Floated',
    [LoanEventType.VIEWED]: 'Viewed',
    [LoanEventType.RELOCKED]: 'Relocked',
    [LoanEventType.COMMENT_CREATED]: 'Comment created',
    [LoanEventType.COMMENT_UPDATED]: 'Comment updated',
    [LoanEventType.COMMENT_DELETED]: 'Comment deleted',
    [LoanEventType.LOAN_STATUS_UPDATED]: 'Loan status updated',
    [LoanEventType.UW_CONDITION_CREATED]: 'Uw condition created',
    [LoanEventType.UW_CONDITION_UPDATED]: 'Uw condition updated',
    [LoanEventType.UW_CONDITION_COMMENT_CREATED]: 'Uw condition comment created',
    [LoanEventType.UW_CONDITION_COMMENT_DELETED]: 'Uw condition comment deleted',
    [LoanEventType.UW_STEP_SUBMITTED]: 'Uw step submitted'
};

export const loanEventTypeMessages: Record<LoanEventType, string> = {
    [LoanEventType.VIEWED]: '**Loan** was **viewed**',
    [LoanEventType.UPDATED]: '**Loan** was **updated**',
    [LoanEventType.CREATED]: '**Loan** was **created**',
    [LoanEventType.PRICED]: '**Loan** was **priced**',
    [LoanEventType.REPRICED]: '**Loan** was **repriced**',
    [LoanEventType.FLOATED]: '**Loan** was **floated**',
    [LoanEventType.LOCKED]: '**Loan** was **locked**',
    [LoanEventType.RELOCKED]: '**Loan** was **relocked**',
    [LoanEventType.COMMENT_CREATED]: '**Comment** was **created**',
    [LoanEventType.COMMENT_UPDATED]: '**Comment** was **updated**',
    [LoanEventType.COMMENT_DELETED]: '**Comment** was **deleted**',
    [LoanEventType.INITIAL_DOC_PACKAGE_UPLOADED]: '**Initial doc package** was **uploaded**',
    [LoanEventType.DOCUMENT_UPLOADED]: '**Document** was **uploaded**',
    [LoanEventType.LOAN_STATUS_UPDATED]: '**Loan status** was **updated**',
    [LoanEventType.UW_CONDITION_CREATED]: '**Underwriting condition** was **created**',
    [LoanEventType.UW_CONDITION_UPDATED]: '**Underwriting condition** was **updated**',
    [LoanEventType.UW_CONDITION_COMMENT_CREATED]: '**Underwriting condition comment** was **created**',
    [LoanEventType.UW_CONDITION_COMMENT_DELETED]: '**Underwriting condition comment** was **deleted**',
    [LoanEventType.UW_STEP_SUBMITTED]: '**Underwriting step** was **submitted**',
    [LoanEventType.SETUP_COMPLETE]: '**Loan setup** was **completed**'
};
